var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex fd-column m-r-3"},[_c('span',{staticClass:"text-lg x-pulse PLACEHOLDER"}),_c('span',{staticClass:"text-lg x-pulse PLACEHOLDER"}),_c('span',{staticClass:"x-pulse PLACEHOLDER"})])
}]

export { render, staticRenderFns }